<template>
  <div
    :class="{ 'base-layout--hide-sidebar': hideSidebar }"
    class="base-layout"
  >
    <grid-container>
      <grid-row>
        <div class="base-layout__sidebar"><slot name="sidebar"/></div>
        <div class="base-layout__content"><slot name="content"/></div>
      </grid-row>
      <grid-row v-if="underline">
        <div class="base-layout__underline"><border-box xs-hide/></div>
        <div class="base-layout__underline"><border-box/></div>
      </grid-row>
    </grid-container>
  </div>
</template>

<script>
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    BorderBox
  },
  props: {
    hideSidebar: {
      type: Boolean,
      default: false
    },
    underline: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .base-layout {
    &__sidebar {
      @include grid-column((xs: 12, lg: 3));

      &:not(:empty) {
        @include vertical-space((bottom: 2), padding);
      }
    }

    &__content {
      @include grid-column((xs: 12, lg: 9));
    }

    &--hide-sidebar &__sidebar {
      @include hide-down(lg);
    }

    &__underline {
      &:first-child {
        @include grid-offset((lg: 3));
        @include grid-column((xs: 12, md: 6, lg: 4));
      }

      &:last-child {
        @include grid-column((xs: 12, md: 6, lg: 5));
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BaseLayout.vue